export default {
      id: "video-event_speeding-usage",
      viewBox: "0 0 24 15",
      url: __webpack_public_path__ + "img/icons.svg#video-event_speeding",
      toString: function () {
        return this.url;
      }
    }